import { HttpClient } from '@angular/common/http';
import { Component, inject, OnInit, Optional } from '@angular/core';
import { appConfigService } from '@app/config';
import { first, switchMap, tap } from 'rxjs';

import { DokumentacijaOpenItemViewActionComponent } from '@app/components/actions/dokumentacija/openitemview-dokumentacija';
import { DokItemInfo } from '@app/components/dokumentacija/dokumentacija-types';
import { SeupPredmet } from '@app/shared/models/seup-predmet';
import {
  AuthRequestOptions,
  ItemProvider,
  ListView,
  ListViewProviderDirective,
  NotificationService,
  ViewWindow,
  WindowRegistry
} from '@ntap/core';

@Component({
  selector: `app-povezi-predmet`,
  templateUrl: './povezi-predmet.component.html'
})
export class PoveziPredmetComponent
  extends DokumentacijaOpenItemViewActionComponent
  implements OnInit
{
  constructor(
    protected override notificationService: NotificationService,
    protected override windowRegistry: WindowRegistry,
    @Optional() protected override window: ViewWindow,
    @Optional() protected override itemProvider: ItemProvider,
    protected listViewProvider: ListViewProviderDirective<ListView>
  ) {
    super(notificationService, windowRegistry, window, itemProvider);
  }

  protected override isDisabled(dokInfo: DokItemInfo): boolean {
    return (
      this.action.disabled ||
      dokInfo.razina != 6 ||
      dokInfo.locked ||
      dokInfo.permission < 2
    );
  }

  public showDialog = false;

  private listviewProvider = inject(ListViewProviderDirective);

  private httpClient = inject(HttpClient);
  private config = inject(appConfigService);
  itemPredmetId: number;

  ngOnInit(): void {
    this.itemProvider.item$
      .pipe(
        first(),
        tap((item: any) => {
          this.itemPredmetId = item['seup~predmet~id'];
        })
      )
      .subscribe();
  }

  public refresh() {
    this.listviewProvider.refresh();
  }

  public onSelectedItem(predmeti: SeupPredmet[]) {
    return this.itemProvider.item$
      .pipe(
        first(),
        switchMap((item: any) => {
          const formData = {
            predmetFromId: predmeti[0]['seup~predmet~id'],
            predmetToId: item['seup~predmet~id']
          };

          return this.httpClient.post(
            `${this.config.apiHost}povezivanje/spoji-predmet`,
            formData,
            new AuthRequestOptions()
          );
        })
      )
      .subscribe({
        next: () => {
          this.listviewProvider.refresh();
        },
        error: () => {
          this.notificationService.error('Pogreška u povezivanju predmeta!');
        },
        complete: () => {
          this.showDialog = false;
        }
      });
  }

  public override executeAction() {
    this.showDialog = true;
  }
}
